export default __webpack_public_path__ + "static/media/INFLUX_DB.bb353fe8.png";